import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'


import {
    FETCH_SELLER_SERVICES,

    UPDATE_SELLER_SERVICE,
} from "actions/actionTypes";
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList} from 'util/Utils';
import SellerServiceListTable from 'sellers/services/SellerServiceListTable';
import SellerServiceSearchBox from 'sellers/services/SellerServiceSearchBox'
import Datetime from 'react-datetime'
import momentTimeZone from 'moment-timezone'
import {checkValidDates, fetchServiceSettings,fetchDateRules, updateSelectedServiceData, findMaximumPickupSize}  from 'shared/sharedMethods';
import config from  '../../../config';
import {validateEmail}  from 'util/Utils';
import RemoveModalDialog from'shared/RemoveModalDialog';


class SellerServicesPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }


    constructor(props, context) {
        super(props, context);
        this.state = {
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            showModal: false,
            PickupDate: false,
            TimeWindow: false,
            serviceAreasForLocation: [],
            ServiceType: '',
            ScheduledPickups: [],
            ScheduledDropoffs: [],
            Size: false,
            currentRecord: {},
            errors: {},
            sortBy: '',
            perPage: config.table.numberPerPage,
            DropoffDateRules:[],
            PickupDateRules:[]
        };

        this.moment = momentTimeZone;
        this.filteredServiceAreasForLocation = []
        this.marketSettings = {}
        this.orderData = {
            'Pickup': {
                maximumSizeNumberForTimeSlot:8,
               // maximumSizeNumberForDay : 18,
                bookNotEarlierThanDaysNumber:3,
                'timeWindowOptions': [],
                sizeOptions: []
            },
            'Dropoff': {
                'timeWindowOptions': [],
                bookNotEarlierThanDaysNumber:0,
             //   maximumSizeNumberForDay : 12,
                sizeOptions:  [],
                DaysOfWeek:[],
            }
        }
    };

    componentWillMount() {

        let queryParams = queryString.parse(this.props.location.search);
         let params = {
            'page': _.isUndefined(queryParams.page) || parseInt(queryParams.page) <= 1 ? 1 : parseInt(queryParams.page),
            perPage: _.isUndefined(queryParams.perPage) ? config.table.numberPerPage : parseInt(queryParams.perPage),
            sortBy: queryParams.sortBy,
            doNotUpdateUrlString: true,
        }
        this.setState({...this.state, ...params})
        if (!_.isUndefined(queryParams.searchText)) {
            params.searchText = queryParams.searchText
        }

        this.search(params)
        var MarketName =_.get(this.props.userReducer, 'seller.MarketName', 'Denver')
        this.moment.tz.setDefault(_.get(_.find(config.warehouseData, {MarketName: MarketName}), 'timeZoneName'));

        fetchServiceSettings.call(this, {MarketName:MarketName})
        fetchDateRules.call(this,{Name:MarketName + 'ServiceDateRules'})
        this.getMarketSettingsData()
    }

    componentWillUnmount() {
        momentTimeZone.tz.setDefault();
        /* restore default timezone to user local timezone*/
    }
    getMarketSettingsData() {
        return  this.props.makeRequest({Name: 'MarketSettings'}, {
            "endpoint": "/settings",
            'not_display_error_message': true,
        }).then(function (res) {
            const {Data={}} = res.data.data[0] ? res.data.data[0] : {}
            this.marketSettings = Data
            return _.get(res.data.data, [0, 'Data'], {})
        }.bind(this))
    }
    getPickupRecords(){ /* get existing service to check available time slots   */
        var self = this;

        var methodData = {
            'endpoint': '/get-pickups',
            'not_display_success_message': true,
        };

        this.props.makeRequest({
             all: true,
            Statuses: ['Active', 'Scheduled'],/* do not query Cancelled services */
            from: momentTimeZone().startOf('day').toDate()
        }, methodData).then(res => {

            var ScheduledPickups = _.map(_.filter(res.data.data, {Type: 'Pickup'}), function (selectedPickup) {
                return {
                    ServiceStartTime: selectedPickup.ServiceStartTime,
                    TimeWindow: selectedPickup.TimeWindow,
                    Size: selectedPickup.Size,
                    ServiceAreaID: selectedPickup.ServiceAreaID,
                }
            })
            var ScheduledDropoffs = _.map(_.filter(res.data.data, {Type: 'Dropoff'}), function (selectedPickup) {
                return {
                    ServiceStartTime: selectedPickup.ServiceStartTime,
                    TimeWindow: selectedPickup.TimeWindow,
                    Size: selectedPickup.Size,
                }
            })

            var PickupsByDate = _.groupBy( ScheduledPickups, function (selectedPickup) {
                return momentTimeZone(selectedPickup.ServiceStartTime).format('MM-DD')

            })
            var DropoffsByDate = _.groupBy(ScheduledDropoffs, function (selectedPickup) {
                return momentTimeZone(selectedPickup.ServiceStartTime).format('MM-DD')

            })
            var PickupsByDateAndServiceAreas = []
            _.forEach(PickupsByDate, function (pickupsByDate, date) {
                PickupsByDateAndServiceAreas[date] = _.groupBy(pickupsByDate, function (pickup) {
                    return pickup.ServiceAreaID

                })
            })

            console.log('res.data.SellerRecord  1', res.data.SellerRecord);

            self.setState({
                ScheduledPickups: PickupsByDateAndServiceAreas,
                ScheduledDropoffs: DropoffsByDate,
            });
        })
    }

    editRecord(row) {
        console.log('row', row);
        //  if (!this.state.ScheduledPickups.length){
        this.getPickupRecords()
        //   }
        var foundTimeWindow = _.find(this.orderData[row.Type].timeWindowOptions, {value: row.TimeWindow})
        this.filteredServiceAreasForLocation = row.ServiceAreaRecord ? [row.ServiceAreaRecord] : []
        //  if (!row.ServiceAreaRecord && row.Type == 'Pickup') {
        //     this.props.displayMessage({
        //         'messageType': 'warning',
        //         'messageCode': 'Service area is not found'
        //     });
        // }
        this.setState({
            showModal: true,
            ServiceType: row.Type,
            serviceAreasForLocation: row.ServiceAreaRecord ? [row.ServiceAreaRecord] : [],
            PickupDate: momentTimeZone(row.ServiceStartTime),
            Size:row.Size,
            TimeWindow: foundTimeWindow ? foundTimeWindow : false,
            currentRecord: {
                ...row,
            },

        }, function () {
            updateSelectedServiceData.call(this )
        });
    }
    cancelRecord(row) {
        var self  = this;
        var methodData = {
            "endpoint": "/pickups"  + '/' + encodeURIComponent(row._id),
            type: "patch",
        };
        self.props.makeRequest({Status:'Cancelled'}, methodData).then(pickupUpdateResponse => {
            self.search()
        }).catch(err => {
        });

    }
    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},
        });
    }

    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: row});
    }


    deleteService( ) {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/pickups",
            messageData: {'#1#': 'Service'},
            messageCode: 'recordDeleted',
        };
        this.props.makeRequest({id:this.state.currentRecord._id }, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
            console.log('e', err);
        });

    }

    validateAndGetPickupFormData() {
        var formData = _.pick(this.state, ['PickupDate' ])
        if (!this.state.TimeWindow) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    TimeWindow: true
                }
            }, () => this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldNotSpecified',
                messageData: {'#1#': 'Pickup time'}
            }));
            return false
        }
        if (this.state.PickupDate == '') {
            this.setState({
                errors: {
                    ...this.state.errors,
                    PickupDate: true
                }
            });
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldNotSpecified',
                messageData: {'#1#': 'Pickup date'}
            });
            return false;
        }

        if (!momentTimeZone(this.state.PickupDate, 'D/M/YYYY').isValid()) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    PickupDate: true
                }
            });
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorDateIsNotValid',
            });
            return false;
        }


        if (!checkValidDates.call(this,{  user: 'user', current: momentTimeZone(this.state.PickupDate)})) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    PickupDate: true
                }
            });
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorDateIsNotAvailable',
            });
            return false;
        }
        formData.TimeWindow = this.state.TimeWindow.value

        if (this.state.Size == false) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    Size: true
                }
            }, () => this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldNotSpecified',
                messageData: {'#1#': (this.state.ServiceType == 'Pickup' ? 'Pick-up' : 'Drop-off') + ' size'}
            }));
            return false;
        }
        formData.Size = this.state.Size


        return formData
    }

    saveRecord() {
        var self = this;
        this.setState({pending: true});
        var formData = this.validateAndGetPickupFormData();
        if (!formData) {
            this.setState({pending: false});
            return false;
        }
        var methodData = {
            "endpoint": "/pickups"  + '/' + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
        };
        self.props.makeRequest(formData, methodData).then(pickupUpdateResponse => {
            self.setState({pending: false});

            self.search()
            self.closeModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }



    onSortChange(field, sortOrder) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        var queryParams = params
        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'PickupNumber' + ':' + (-1);
        }
        var methodData = {
            "endpoint": "/get-pickups",
            'not_display_success_message': true,
            'success_event': FETCH_SELLER_SERVICES
        };

        if (_.isUndefined(params.doNotUpdateUrlString)) {
            const stringified = queryString.stringify(_.omit(queryParams,['include', 'lookup', 'all','sortBySecondary']));
            this.context.router.push('/client/dashboard/services?' + stringified);
        }
        queryParams.lookup = ['Sellers', 'ServiceArea']
        queryParams.SellerID = this.props.userReducer.seller._id;
        return this.props.makeRequest(queryParams, methodData).then(res => {
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                console.log('before reset pagination');
                this.refs.pagination.resetPagination();
            }
        }).catch(err => {
        });
    }

    onDateChange(option) {
        var d = momentTimeZone(option, 'D/M/YYYY');

        if (d == null || !d.isValid()) {
            this.setState({
                errors: {
                    ...this.state.errors,
                    PickupDate: true
                }, PickupDate: false,
            }, function () {

            });
            return false;
        }
        this.setState({
            'PickupDate': option, errors: {
                ...this.state.errors,
                PickupDate: false
            }
        }, function () {
            updateSelectedServiceData.call(this )
        });
    }


    render() {
        console.log('SellerServicesPage this state', this.state);
         return (
            <div >

                {/*<SellerServiceSearchBox*/}
                    {/*ref="searchBox"*/}
                    {/*//  addNewService={this.addNewService.bind(this)}*/}
                    {/*search={this.search.bind(this)}*/}
                    {/*{...this.props} ></SellerServiceSearchBox>*/}
                {this.props.sellerServices.fetched &&
                <div>
                    {this.props.sellerServices.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'services')}</div> :
                        <div className="top20">

                            <SellerServiceListTable
                                onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                editRecord={this.editRecord.bind(this)}
                                cancelRecord={this.cancelRecord.bind(this)}
                                orderData={this.orderData}
                                marketSettings={this.marketSettings}
                                search={this.search.bind(this)} {...this.props}  ></SellerServiceListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={  _.get(queryString.parse(this.props.location.search), ['perPage'], config.table.numberPerPage)}
                                ref={'pagination'}
                                 total={this.props.sellerServices.total == 'initial' ? 0 : this.props.sellerServices.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }

                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{ 'Edit'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form  >

                            <FormGroup>
                                <ControlLabel>{ (this.state.ServiceType == 'Pickup' ? 'Pick-up' : 'Drop-off') + ' date'}</ControlLabel>
                                <Datetime
                                    isValidDate={(date) => checkValidDates.call(this, {
                                        user: 'user',
                                        filterServiceAreas: false,
                                        current: date
                                    }) }
                                    closeOnSelect={true}
                                    dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                    onChange={(value) => this.onDateChange.call(this, value)}
                                    inputProps={{
                                        placeholder: (this.state.ServiceType == 'Pickup' ? 'PICK-UP' : 'DROP-OFF') + ' DATE',

                                    }}
                                    value={this.state.PickupDate}
                                    className={this.state.errors['PickupDate'] ? "red-border-date-picker " : ""}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Time</ControlLabel>
                                <Select
                                    options={ _.get(this.orderData, [this.state.ServiceType, 'timeWindowOptions'], [])}
                                    onChange={ (option) => {
                                        this.setState({'TimeWindow': option ? option : false}, function () {
                                            updateSelectedServiceData.call(this, {user:'user'})
                                        });
                                    }}
                                    value={this.state.TimeWindow}
                                    onFocus={(e) => this.setState({
                                        errors: {
                                            ...this.state.errors,
                                            TimeWindow: false
                                        }
                                    }) }
                                    style={this.state.errors['TimeWindow'] ? {border: '1px solid red'} : {} }
                                />
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Size</ControlLabel>
                                <Select
                                    options={ _.get(config.services,[this.state.ServiceType.toLowerCase(), 'sizeOptions'],[])  }
                                    onChange={ (option) => {
                                        this.setState({
                                            'Size': option ? option.value : false, errors: {
                                                ...this.state.errors,
                                                Size: false
                                            }
                                        }, function () {
                                            updateSelectedServiceData.call(this )
                                        })}}

                                    placeholder="Size"
                                    value={this.state.Size}
                                    onFocus={(e) => this.setState({
                                        errors: {
                                            ...this.state.errors,
                                            Size: false
                                        }
                                    }) }
                                    style={this.state.errors['Size'] ? {border: '1px solid red'} : {} }
                                />
                            </FormGroup>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.deleteService() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        sellerServices: state.sellerServices,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SellerServicesPage);
